const withQuery = (url, params) => {
  let query = Object.keys(params)
    .filter(k => params[k] !== undefined)
    .map(k => encodeURIComponent(k) + '=' + encodeURIComponent(params[k]))
    .join('&');
  url += (url.indexOf('?') === -1 ? '?' : '&') + query;
  return url;
};
export default withQuery;
